import { Skeleton } from '@heroui/react';

export const ProductPrice = ({
  text,
  isDiscount = false,
  isLoading = false,
}: {
  text: string;
  isDiscount?: boolean;
  isLoading?: boolean;
}) => {
  return (
    <Skeleton isLoaded={!isLoading} className="rounded-md">
      {isDiscount && (
        <p className="text-sm text-[#9CA5AC] line-through">{text} ₸</p>
      )}
      {!isDiscount && (
        <p className="text-md font-semibold text-[#222222] break-all h-6 line-clamp-1 overflow-ellipsis">
          {text} ₸
        </p>
      )}
    </Skeleton>
  );
};
